/* SP Menu Enhance — mejora de usabilidad del menú móvil.
   1) Toggle de búsqueda (lupa <-> X) junto al botón de menú; colapsa la barra de búsqueda.
   2) Desplegable (drawer nativo): añade iconos por sección, banner por desplegable,
      y un pie con teléfonos/horario + idioma/divisa.
   Lee datos ya presentes en el DOM (topbar y megamenú, ocultos en móvil). Idempotente. */
(function () {
  'use strict';

  var ICON_SEARCH = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.5-3.5"></path></svg>';
  var ICON_CLOSE = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"></path></svg>';
  var ICON_PHONE = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2z"></path></svg>';
  var ICON_CLOCK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path></svg>';

  function txt(el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }
  function handleize(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function titleCase(s) { s = (s || '').trim(); return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); }
  var ICON_CHEV = '<svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 4.5 6 8l3.5-3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- 1. Toggle de búsqueda ---------- */
  function initSearchToggle() {
    var searchSection = document.querySelector('.sp-header-search-section');
    var cols = document.querySelector('.header__row--top .header__columns') ||
               document.querySelector('.header__columns');
    if (!searchSection || !cols) return;
    if (cols.querySelector('.sp-search-toggle')) return;

    searchSection.classList.add('sp-search-collapsed');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sp-search-toggle';
    btn.setAttribute('aria-label', 'Buscar');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = ICON_SEARCH;
    btn.addEventListener('click', function () {
      var open = !searchSection.classList.contains('sp-search-open');
      searchSection.classList.toggle('sp-search-open', open);
      searchSection.classList.toggle('sp-search-collapsed', !open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.innerHTML = open ? ICON_CLOSE : ICON_SEARCH;
      if (open) {
        var inp = searchSection.querySelector('.sp-search__input');
        if (inp) setTimeout(function () { inp.focus(); }, 60);
      }
    });
    cols.appendChild(btn);
  }

  /* ---------- 2. Datos del megamenú (iconos + banner) ---------- */
  function megamenuMap() {
    var map = {};
    document.querySelectorAll('.spnav__item').forEach(function (it) {
      var label = txt(it.querySelector('.spnav__link span'));
      if (!label) return;
      map[label.toUpperCase()] = {
        icon: it.querySelector('.spnav__icon'),
        promo: it.querySelector('.spnav__promo')
      };
    });
    return map;
  }

  function enhanceDrawer() {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer) return;
    var map = megamenuMap();

    drawer.querySelectorAll('.menu-drawer__menu > li').forEach(function (li) {
      var head = li.querySelector('.menu-drawer__menu-item--mainlist') ||
                 li.querySelector('a.menu-drawer__menu-item');
      if (!head) return;
      var labelEl = head.querySelector('.menu-drawer__menu-item-text') || head;
      var data = map[txt(labelEl).toUpperCase()];
      if (!data) return;

      // Icono
      if (data.icon && !head.querySelector('.sp-drawer-ico')) {
        var ic = data.icon.cloneNode(true);
        ic.className = 'sp-drawer-ico';
        ic.removeAttribute('width'); ic.removeAttribute('height');
        head.insertBefore(ic, head.firstChild);
      }
      // Banner del desplegable → DENTRO del área scrollable (forma parte del contenido,
      // no fijo abajo: al desplegar un grupo el banner baja y se ve haciendo scroll).
      if (data.promo) {
        var sub = li.querySelector('.menu-drawer__submenu');
        var host = (sub && sub.querySelector('.menu-drawer__inner-submenu')) || sub;
        if (host && !host.querySelector('.sp-drawer-promo')) {
          var promo = data.promo.cloneNode(true);
          promo.classList.add('sp-drawer-promo');
          host.appendChild(promo);
        }
      }
    });

    // Pie: contacto + idioma
    var nav = drawer.querySelector('.menu-drawer__navigation') || drawer;
    if (!nav.querySelector('.sp-drawer-foot')) {
      var foot = buildFooter();
      if (foot) nav.appendChild(foot);
    }

    enhanceSubmenus(drawer);
  }

  // "Ver todo" por categoría + convertir los grupos L2 (POR MARCAS/NIVEL/FORMA…) en acordeones.
  function enhanceSubmenus(drawer) {
    drawer.querySelectorAll('.menu-drawer__menu > li').forEach(function (li) {
      var head = li.querySelector('.menu-drawer__menu-item--mainlist');
      var sub = li.querySelector('.menu-drawer__submenu');
      if (!head || !sub) return;
      var inner = sub.querySelector('.menu-drawer__inner-submenu') || sub;
      var title = txt(head.querySelector('.menu-drawer__menu-item-text') || head);

      // 1) "Ver todo" junto al nombre de la categoría, a la derecha (cerca de la X)
      var header = inner.querySelector('.menu-drawer__nav-buttons');
      if (title && header && !header.querySelector('.sp-drawer-viewall')) {
        var a = document.createElement('a');
        a.className = 'sp-drawer-viewall';
        a.href = '/collections/' + handleize(title);
        a.innerHTML = 'Ver todo <span aria-hidden="true">→</span>';
        var closeBtn = header.querySelector('button:not(.menu-drawer__back-button)');
        if (closeBtn) header.insertBefore(a, closeBtn);
        else header.appendChild(a);
      }

      // 2) Grupos L2 → acordeones plegables (colapsados por defecto)
      inner.querySelectorAll('li.menu-drawer__list-item').forEach(function (g) {
        var parent = g.querySelector('.menu-drawer__menu-item--parent');
        var glist = g.querySelector('.menu-drawer__menu--grandchildlist');
        if (!parent || !glist || g.dataset.spAcc === '1') return;
        g.dataset.spAcc = '1';
        g.classList.add('sp-l2', 'sp-l2--collapsed');
        if (!parent.querySelector('.sp-l2__chev')) {
          var chev = document.createElement('span');
          chev.className = 'sp-l2__chev';
          chev.innerHTML = ICON_CHEV;
          parent.appendChild(chev);
        }
        // El toggle va por DELEGACIÓN (abajo): el drawer nativo re-hidrata y clona el DOM,
        // así que los listeners por-nodo se pierden; la delegación en document sobrevive.
      });
    });
  }

  function buildFooter() {
    var phones = [].slice.call(document.querySelectorAll('.sp-topbar__item[href^="tel"]'));
    var schedule = '';
    document.querySelectorAll('.sp-topbar__item--muted').forEach(function (el) {
      if (!el.getAttribute('href')) schedule = txt(el);
    });
    var selectors = [].slice.call(document.querySelectorAll('.sp-topbar__selector')).map(txt).filter(Boolean);
    if (!phones.length && !schedule && !selectors.length) return null;

    var foot = document.createElement('div');
    foot.className = 'sp-drawer-foot';
    var html = '';
    if (phones.length || schedule) {
      html += '<div class="sp-drawer-foot__contact">';
      phones.forEach(function (p) {
        html += '<a class="sp-drawer-foot__phone" href="' + p.getAttribute('href') + '">' + ICON_PHONE + '<span>' + txt(p) + '</span></a>';
      });
      if (schedule) html += '<div class="sp-drawer-foot__hours">' + ICON_CLOCK + '<span>' + schedule + '</span></div>';
      html += '</div>';
    }
    if (selectors.length) {
      html += '<div class="sp-drawer-foot__loc">' + selectors.map(function (s) { return '<span>' + s + '</span>'; }).join('') + '</div>';
    }
    foot.innerHTML = html;
    return foot;
  }

  // Toggle de los grupos L2 por delegación (capture) → sobrevive a la re-hidratación del drawer.
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('.menu-drawer__submenu .sp-l2 > .menu-drawer__menu-item--parent');
    if (!p) return;
    var g = p.closest('.sp-l2');
    if (!g) return;
    e.preventDefault();
    g.classList.toggle('sp-l2--collapsed');
  }, true);

  function run() {
    if (isMobile()) { initSearchToggle(); enhanceDrawer(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('load', run);
  // Reintentos: el <header-drawer> se hidrata de forma asíncrona (el .menu-drawer
  // puede no existir aún en DOMContentLoaded/load).
  [300, 900, 1800].forEach(function (ms) { setTimeout(run, ms); });

  // Al abrir el desplegable, garantizar el enriquecido (idempotente).
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.menu-drawer-container > summary, .header__icon--menu, .menu-drawer-container summary')) {
      setTimeout(function () { if (isMobile()) enhanceDrawer(); }, 40);
    }
  }, true);

  // Observer de respaldo: enriquecer en cuanto aparezca el .menu-drawer.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      if (isMobile() && document.querySelector('.menu-drawer') &&
          !document.querySelector('.sp-drawer-foot')) {
        enhanceDrawer();
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
